import React from 'react';
import { Outlet } from 'react-router-dom';

const OutletWrapper = () => <Outlet />;

export default OutletWrapper;
